import $ from 'jquery';
import { formatMoney } from './tools/moneyFormats';
import header from './modules/header';
import slider from './modules/slider';
import smoothScroll from './modules/smoothScroll';
import {
  scroll
} from './modules/smoothScroll';
import qty from './modules/qty-selector';
import product from './modules/product';
import login from './modules/login';
import customerAddresses from './modules/account';
import animation from './modules/animation';
import cartPage from './modules/cartPage';
import instagramFeed from './modules/instagramFeed';
import popup from './modules/popup';
import minicart from './modules/minicart';
import recommendations from './modules/product/recommendations';
import changeproduct from './modules/product/changeProduct';
import megamenu from './modules/megamenu';
import search from './modules/search';
import quickView from './modules/quickView';
import product_choose from './modules/product_choose';
import product_feature from './modules/product_feature';
import addSubscription from './modules/addSubscription';
import videoComponent from './modules/videoComponent';
import tabsComponent from './modules/tabsComponent';
import stickyInfoComponent from './modules/stickyInfoComponent';
import verticalSlider from './modules/verticalSlider';
import videoPlay from './modules/videoPlay';
import ingredient from './modules/ingredient';
import event from './modules/eventListner';
import videoSlider from './modules/videoSlider';
import extra from './modules/extra';
import autoscroll from './modules/autoscroll';
import reviewSlide from './modules/reviewSlide';
import mobileBanners from './modules/mobileBanners';
import mobileSlide from './modules/mobileSlide';
import gridVideos from './modules/gridVideos';
import productStickyBar from './modules/productStickyBar';

window.$ = window.jQuery = $;

const register = function (f, args) {
  try {
    f(args);
    if (args && args.resize) {
      $(window).resize(function () {
        f(args);
      })
    }
  } catch (e) {
    console.error(e);
  }
}

const trigger = () => {
  $('[data-trigger]').click(function (e) {
    e.preventDefault();
    $('[data-trigger]').not($(this)).removeClass('is-open');
    $(this).toggleClass('is-open');
  })
  $('[data-trigger-hover]').mouseover(function (e) {
    e.preventDefault();
    $('[data-trigger]').removeClass('is-open');
  })
  $(document).on('click', function (e) {
    const trigger = '[data-trigger]';
    const $target = $(e.target);
    const $trigger = $target.closest(trigger);
    const $next = $(trigger).next();
    const isNext = $next.find($target).length;

    if ($trigger.length || isNext) return;
    $(trigger).removeClass('is-open');
  });
}

const tabs = () => {
  $(".press-icon").hide();
  $('[data-tab]').click(function (e) {
    e.stopPropagation();
    const index = $(this).data('tab');
    const $parent = $(this).closest('[data-tabs]');
    const site_url = location.href;
    $('[data-tab], [data-tab-content]', $parent).removeClass('is-active');
    $(this).addClass('is-active');
    $(`[data-tab-content=${index}]`, $parent).addClass('is-active');

    if (site_url.indexOf("in-the-press") != -1) {
      if (index == 'press') {
        $(".press-products").show();
        $(".press-icon").hide();
        $(".hero__container.gift").hide();
        $(".hero__container.press").show();
      } else if (index == 'gift-card') {
        $(".press-products").hide();
        $(".press-icon").show();
        $(".hero__container.gift").show();
        $(".hero__container.press").hide();
      }
      //if($(window).width() < 768) {
      setTimeout(function () {
        $(".tab-content.is-active[data-hor-slider]").slick("refresh");
      }, 10)
      //}
    }
  });
}

const filter = () => {
  const storageIndex = localStorage.getItem('collection-tab');
  if (storageIndex) {
    $('[data-collection-tabs] [data-tab]').removeClass('is-active');
    $(`[data-collection-tabs] [data-tab=${storageIndex}]`).addClass('is-active');
    $('[data-collection-tabs] [data-tab-content]').removeClass('is-active');
    $(`[data-collection-tabs] [data-tab-content=${storageIndex}]`).addClass('is-active');
  }
  $('[data-collection-tabs] .nav__link').click(function () {
    const index = $(this).closest('[data-tab-content]').data('tab-content');
    localStorage.setItem('collection-tab', index);
  })
}

const video = function () {
  const video = $('[data-video] video');
  const btn = $('[data-video-btn]');
  btn.click(function (e) {
    $(this).siblings('video').click();
  });
  video.each(function (index, videoEl) {
    $(videoEl).on('play seeking', function () {
      // $(this).attr('controls', true);
      $(this).siblings('button').hide();
      $(this).closest('[data-video]').addClass('is-playing');
    })
    $(videoEl).on('seeked', function () {
      $(this)[0].play()
    })
    $(videoEl).on('pause', function () {
      $(this).removeAttr('controls');
      $(this).siblings('button').show();
      $(this).closest('[data-video]').removeClass('is-playing');
    })
  });
}

const handleGotop = function () {
  const gotop = $('[data-gotop]');
  $(document).scroll(function () {
    const scroll = $(this).scrollTop();
    if (scroll >= $(window).height()) {
      gotop.show();
    } else {
      gotop.hide();
    }
  });
}

const accordions = function () {
  $(document).on('click', '[data-accordion-title]', function (event) {
    event.preventDefault();
    const $container = $(this).closest('[data-accordions-container]');

    if ($container.data('accordions-mobile-only') == "1" && $(window).outerWidth() > 989) {
      return false;
    }

    const $currentBtn = $(this);
    const $currentContent = $(this).siblings('[data-subaccordion]');
    $currentBtn.toggleClass('is-open');
    $currentContent.slideToggle();
    $('[data-accordion-title]', $container).not($currentBtn).removeClass('is-open');
    $('[data-subaccordion]', $container).not($currentContent).slideUp();
  });
  $(document).on('click', '[data-accordion-button]', function (event) {
    event.preventDefault();
    const $container = $(this).closest('[data-accordions-container]');

    if ($container.data('accordions-mobile-only') == "1" && $(window).outerWidth() > 989) {
      return false;
    }

    const $currentBtn = $(this);
    const $currentContent = $(this).siblings('[data-accordion-content]');
    $currentBtn.toggleClass('is-open');
    $currentContent.slideToggle();
    $('[data-accordion-button]', $container).not($currentBtn).removeClass('is-open');
    $('[data-accordion-content]', $container).not($currentContent).slideUp();
  });
}

const faq = function () {
  const $toggle = $('[data-faq-section-toggle]');
  const $section = $('[data-faq-section]');
  if ($toggle.length) {
    $toggle.on('click',function (e) {
      const currentSection = $(this).data('faq-section-toggle');
      $toggle.removeClass('is-active');
      $(this).addClass('is-active');
      $section.removeClass('is-active');
      $section.filter(`[data-faq-section=${currentSection}]`).addClass('is-active');
    });
  }
}

const stickyFooter = function () {
  const update = () => {
    setTimeout(() => {
      if ($(window).width() <= 989) {
        $('body').css('paddingBottom', 0);
        $('[data-site-footer]').show();
        return false;
      }
      var height = $('[data-site-footer]').outerHeight();
      $('body').css({
        'paddingBottom': height
      });
      $('[data-site-footer]').show();
    }, 250);
  }
  update();
  $(window).on("resize",update)
}

const themeEditor = function () {
  if (Shopify.designMode) {
    $('body').removeClass('animations-on');
  }
}

const toggleTarget = function () {
  $('[data-toggle]').click(function () {
    const target = $(this).data('toggle');
    const $target = $(`[data-target=${target}]`);
    $target.toggleClass('is-active');
  })
}

const goTo = function () {
  $('[data-goto]').click(function () {
    const target = $(this).data('goto');
    const $target = $(`[data-goto-target=${target}]`);
    $(this).closest('[data-goto-target]').addClass('hide');
    $target.removeClass('hide');
  })
}

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //Максимум не включается, минимум включается
}

const misc = function () {
  $('[data-random-number]').text(getRandomInt(2, 9))
}

const btnSectionScroll = function () {
  $(".btn.add-to-cart:not([data-add-to-cart])").click(function (e) {
    e.preventDefault();

    if (($(this).text().toLowerCase() == "order now") && $(".product-main").length) {
      $("html, body").animate({
        scrollTop: 0
      }, "slow");
    } else {
      const href = $(this).attr('href');
      window.location.href = href;
    }
  });
}

const collectionChange = function () {
  $('[data-collection-button]').click(function (e) {
    e.preventDefault();
    $('[data-collection-button]').removeClass('active');
    $(this).addClass('active');
    const target = $(this).data('target');
    const $target = $(`[data-wrap=${target}]`);
    $('.collecttionwrap').removeClass('active').hide();
    $target.addClass('active').css({
      'opacity': 0
    }).animate({
      'opacity': 1
    }).show();
    history.pushState('', '', $(this).attr('data-target'));
  })
}

const customStickyEvent = function () {
  $(document).on("click", ".custom-variants_select", function () {
    $(this).toggleClass("open");
  })
}

const customStickyChange = function () {
  $(document).on("click", ".custom-variants_select.open div[data-variant_id]", function () {
    if (!$(this).hasClass("active")) {
      $(this).closest(".custom-variants_select").find("div.active").removeClass("active");
      $(this).addClass("active");
      var variant_id = $(this).attr("data-variant_id");
      $(this).closest(".custom-variants_select").next(".sticky-variants").val(variant_id).trigger("change");
      var is_available = $(this).closest(".custom-variants_select").next(".sticky-variants").find("option[value=" + variant_id + "]").attr("data-available");
      //  UPDATED 3rd Jan 2025
      // Both var getstickyprice and stickyPrice can be removed to get back to original code as well as updating $(this).attr("data-price", stickyPrice) to $(this).attr("data-price") for both.
      var getstickyprice = $(this).attr("data-price");
      var stickyPrice = getstickyprice.split('.')[0];
      if (is_available == 'true') {
        $(this).closest(".sticky-form").find("[data-add-to-cart]").removeAttr("disabled");
        $(this).closest(".sticky-form").find("[data-add-to-cart]").html("Add To Cart - <span>" + stickyPrice + "</span>");
      } else {
        $(this).closest(".sticky-form").find("[data-add-to-cart]").attr("disabled", true);
        $(this).closest(".sticky-form").find("[data-add-to-cart]").html("Sold Out - <span>" + stickyPrice + "</span>");
      }
    }
  })
}

const pressScrollToTop = function () {

  $('.slick-slider[data-tab-content]').on('afterChange', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });

}

function buttonLoadOff (btn) {
  const spinner = btn.querySelector('.loading-overlay__spinner');
  btn.classList.remove('loading');
  btn.removeAttribute('aria-disabled');
  if (spinner) spinner.classList.add('hidden');
}

$(document).ready(() => {
  register(header);
  register(stickyFooter);
  register(slider);
  register(video);
  register(handleGotop);
  register(product);
  register(qty);
  register(accordions);
  register(smoothScroll);
  register(login);
  register(customerAddresses);
  register(animation);
  register(cartPage);
  register(popup);
  register(faq);
  register(themeEditor);
  register(trigger);
  register(tabs);
  register(filter);
  register(toggleTarget);
  register(goTo);
  register(minicart);
  register(recommendations);
  register(misc);
  register(btnSectionScroll);
  register(instagramFeed);
  register(megamenu);
  register(changeproduct);
  register(search);
  register(quickView);
  register(product_choose);
  register(product_feature);
  register(addSubscription);
  // register(gsapAnimation);
  register(verticalSlider);
  register(videoPlay);
  register(ingredient);
  register(collectionChange);
  register(event);
  register(videoSlider);
  register(extra);
  register(customStickyEvent);
  register(customStickyChange);
  register(autoscroll);
  register(reviewSlide);
  register(mobileBanners);
  register(videoComponent);
  register(stickyInfoComponent);
  register(mobileSlide);
  register(gridVideos);
  register(tabsComponent);
  register(productStickyBar);


  $('body').on('click','.redeem-offer',function(e){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var _klOnsite = window._klOnsite || [];
    _klOnsite.push(['openForm', 'Ukrhwk']);
    $('.klaviyo-form-popup').addClass('open-popup');
    $('body,html').addClass('no-scroll');
    return false;
  });

  $('.klaviyo-form-popup').on('click','[data-popup-close]',function(e){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    $('.klaviyo-form-popup').removeClass('open-popup');
    $('body,html').removeClass('no-scroll');
  });

  window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type == "redirectedToUrl" && e.detail.formId == "Ukrhwk") {
      // $('.klaviyo-form-popup').removeClass('open-popup');
      // $('body,html').removeClass('no-scroll');
      $('.klaviyo-form-popup').addClass('loading');
      $('.klaviyo-form-popup button.needsclick').append('<div class="loader-wapper"></div>');
      $('.orginal-add-to-cart button').trigger('click');
    }
  });
  register(pressScrollToTop);
});

$(document).ready(function(){
  $('.product-compare-item__product').find('.product-option').find('label').click(function(){
      var variantId = $(this).data('variant-id');
      $('.product-add-btns').find('.product-option').find(`[data-variant-id="${variantId}"]`).click();
  });

  $('.info-wrapper').click(function(e){
      e.stopPropagation();
      $(this).toggleClass('active');
  });

  $('body').on('mousedown', function(){
      $('.info-wrapper').removeClass('active');
  });

  $('.print-recipe').on('click', function(){
    window.print();
  });
});

const $compareProducts = $('.product-compare-item__product').find('.product-compare-content');
const $compareTable = $('#shopify-section-ea-product-compare');

if ($compareTable.length > 0 && $compareProducts.length > 0) {
  const compareProductsTop = $compareProducts.position().top;
  const compareTableBottom = $compareTable.position().top;

  $(window).on('scroll', function(){
    var st = $(this).scrollTop();
    var height = $(this).height();
    var width = $(this).width();
    if (width < 768) {
      if (st > compareProductsTop + height + 100) {
        $compareTable.addClass('compare-sticky');
      } else {
        $compareTable.removeClass('compare-sticky');
      }

      if (st > compareTableBottom) {
        $compareTable.removeClass('compare-sticky');
      }
    }
  });
}

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('[data-type=add-to-cart-form]');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.product = JSON.parse(this.querySelector('.product-json').textContent)
    this.quantitySelector = this.querySelector('quantity-input')
    this.cartPopup = document.querySelector('[data-minicart]');

    if (this.form.elements.add && this.isIterable(this.form.elements.add)) {
      this.addButtons = this.form.elements.add;
    } else {
      this.addButtons = [this.form.elements.add];
    }

  }

  onSubmitHandler(e) {
    e.preventDefault();

    this.addButtons.forEach(btn => {
      const spinner = btn.querySelector('.loading-overlay__spinner');

      if (btn.classList.contains('loading')) return;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
      this.handleErrorMessage(false, btn);
    })

    const items = [];
    const mainItem = this.createFormDataItem(this.form);

    items.push(mainItem);

    const successCallback = function (response) {
      if (response.status) {
        this.addButtons.forEach(btn => this.handleErrorMessage(response.description, btn))
      }
    }
    const finallyCallback = function () {
      this.addButtons.forEach(btn => {
        buttonLoadOff (btn)
      })
    }
    window.newAddToCart(items, true, successCallback.bind(this), null, finallyCallback.bind(this));
  }

  isIterable(obj) {
    return typeof obj[Symbol.iterator] === 'function';
  }

  createFormDataItem(form) {
    if (!form) {return false}
    const formData = new FormData(form);
    const item = {}

    formData.forEach((value, key) => {
      const lastStr = key.charAt(key.length - 1)

      if (key.includes('properties') && lastStr === ']') {
        const newKey = key.substring(key.indexOf('[') + 1, key.indexOf(']'));

        if (item['properties']) {
          item['properties'][newKey] = value;
        } else item['properties'] = {[newKey]: value};

      } else item[key] = value;
    });

    return item || false;
  }


  handleErrorMessage(errorMessage = false, btn) {
    this.errorMessageWrapper = this.form.querySelector('[data-error-wrapper]');
    if (!this.errorMessageWrapper) return
    this.errorMessage = this.errorMessageWrapper.querySelector('[data-error-message]');

    if (errorMessage) {
      this.errorMessageWrapper.classList.remove('visually-hidden');
      this.errorMessage.textContent = errorMessage;
    }

    this.hideErrorMessage (this.errorMessageWrapper, errorMessage)
  }

  hideErrorMessage(errorMessageWrapper, errorMessage) {
    setTimeout( () => {
      errorMessageWrapper.classList.add('visually-hidden');
      if (errorMessage) this.errorMessage.textContent = '';
    }, 5000)
  }

  toggleAddButton(available = true, text, hide = false, preorder = false) {
    if (!this.addButtons) return;
    let addButtonStatus = 'enabled';

    if (!available) {
      addButtonStatus = 'disabled'
      if (!text) text = window.variantStrings.soldOut
    } else {
      if (preorder) {
        if (!text) text = window.variantStrings.preorder
      } else {
        if (!text) text = window.variantStrings.addToCart
      }
    }

    this.addButtons.forEach(btn => {
      const textInner = btn.querySelector('span');
      (addButtonStatus === 'enabled')
          ? btn.removeAttribute('disabled')
          : btn.setAttribute('disabled', 'disabled');
      textInner.textContent = text
    })
  }
}

customElements.define('product-form', ProductForm);

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.url = String(window.location.href);
    this.productForm = this.querySelector('product-form') || null;
    this.price = {
      price: this.querySelector('[data-price]'),
      comparePrice: this.querySelector('[data-price-compare]'),
      priceSave: this.querySelector('[data-price-save]')
    }
    this.optionTitles = this.querySelectorAll('[data-option-title]');
    this.stickyBar = document.querySelector('product-sticky');
    this.button = this.querySelector('button[type="submit"]') || null;
    this.variantImages = this.querySelectorAll('.js-variant-image') || null;
    this.cardColor = this.querySelector('.product__option-item-color') || null;
    if (this.cardColor && this.productForm.product) {
      const selectColor = this.cardColor.querySelector('input:checked');
      this.currentVariant = this.changeCurrentVariant(selectColor.value, this.productForm.product.variants)
    }

    this.bundlePrice = $(this).parents('.bundle-compare__product-wrapper').find('.bundle-compare__product-title-wrapper').find('.product-price__save');

    if(this.productForm) this.btnLink = this.querySelector('.product-card__btn-wrapper a') || null;

    this.init();
  }

  init() {
    if(this.button) {
      this.button.addEventListener('mousedown mouseup', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
      })
    }

    this.addEventListener('change', this.changeOnSwatches);
    this.endLoadBtn();
  }

  changeOnSwatches(event) {
    this.updateOptions();
    this.updateMasterId();

    if (event && event.target.hasAttribute('data-single-option-color')) {
      this.changeColorSwatch(event.target);
    }

    if(this.stickyBar && event) this.stickyBar.changeVariant(this.currentVariant.title);
  }

  updateMasterId() {
    this.currentVariant = this.productForm.product.variants.map((variant, i)=> {
      if (!variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false)) {
        return variant;
      }
    });
    this.currentVariant = this.currentVariant.find(v => v);
  }

  updateOptions() {
    const fieldsets = Array.from(this.productForm.querySelectorAll('fieldset'));

    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateCheckedVariants() {
    const fieldsets = Array.from(this.productForm.querySelectorAll('fieldset'));

    this.currentVariant.options.forEach(optionValue => {
      fieldsets.forEach((fieldset) => {
        const input = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.value == optionValue);
        if (typeof input === "object") input.checked = true;
      });
    });
  }

  changeOptionsTitle() {
    if(!this.optionTitles.length > 0) return;
    const optionTitlesArr = Array.from(this.optionTitles);

    optionTitlesArr.forEach((item,index) => {
     if (this.currentVariant.options[index]) item.innerHTML = this.currentVariant.options[index];
    })
  }

  changeCurrentVariant(title, objects) {
    return objects.find(object => object.title === title);
  }

  changeColorSwatch () {
    const variantOptions = this.currentVariant.options,
        currentID = `${this.currentVariant.id}`,
        price = this.currentVariant.price,
        comparePrice = this.currentVariant.compare_at_price,
        savePrice = this.currentVariant.compare_at_price - this.currentVariant.price,
        variantAvailable = this.currentVariant.available;

    this.changeVariantImage(variantOptions);
    this.changePrice(price, comparePrice, savePrice);
    this.changeSelectId(currentID);
    this.changeOptionsTitle();
    if (this.button) this.changeButton(variantAvailable);
  }

  changeButton (boolean) {
    const $addText = this.button.querySelector('.product-form__submit-text');
    const $soldOut = this.button.querySelector('.sold-out-message');

    if (boolean === false ) {
      this.button.setAttribute('disabled', 'disabled');
      $soldOut.classList.remove('visually-hidden');
      $addText.classList.add('visually-hidden');
    } else {
      $addText.classList.remove('visually-hidden');
      $soldOut.classList.add('visually-hidden');
      this.button.removeAttribute('disabled');
    }
  }

  changeSelectId(variantId) {
    const select = this.productForm.form.elements.id;

    if (select) select.value = `${variantId}`;
  }

  changeVariantImage(variantOptions) {
    let currentImage;

    this.variantImages.forEach((image) => {
      if (!variantOptions) return;

      variantOptions.forEach(option => {
        if (image.getAttribute('data-variant-image-title') !== option) {
          if ( image.classList.contains('active')) image.classList.remove('active');
        } else if (image.getAttribute('data-variant-image-title') === option) {
          currentImage = image;
        }
      })
    });

    currentImage.classList.add('active');
  }

  changePrice(price, comparePrice, priceSave) {
    if (this.price.price) {
      this.price.price.innerHTML = formatMoney(price, "${{amount_no_decimals}}");
    }
    if (this.price.comparePrice && comparePrice) {
      this.price.comparePrice.innerHTML = formatMoney(comparePrice, "${{amount_no_decimals}}");
    }

    if (this.price.priceSave && priceSave && priceSave > 0) {
      this.price.priceSave.innerHTML = 'Save $'+formatMoney(priceSave, "{{amount_no_decimals}}");

      if (this.bundlePrice.length > 0) this.bundlePrice[0].innerHTML = 'Save $'+formatMoney(priceSave, "{{amount_no_decimals}}");
    }
  }

  endLoadBtn() {
    if(this.productForm === null) return;

    const btn = this.button;
    const spinner = btn.querySelector('.loading-overlay__spinner');

    btn.classList.remove('loading');
    btn.removeAttribute('aria-disabled');
    if (spinner) spinner.classList.add('hidden');
  }
}

customElements.define('product-card', ProductCard);

class customSelect extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.form-select__btn');
    this.dropdownLabel = this.querySelector('.form-select__dropdown-option--label');
    this.buttonText = this.button.querySelector('.form-select__btn-text');
    this.list = this.querySelector('.form-select__dropdown');
    this.inputHidden = this.querySelector('.form__input-hidden');
    this.isAlternative = this.classList.contains('form-select__alternative');
    this.changeEvent = new Event('change', { bubbles: true })

    this.button.addEventListener('click', (e) => {
      this.button.getAttribute('aria-expanded') === 'true' ? this.close() : this.open();
    })

    if (window.isIosDevice) {
      const _self = this;

      window.addEventListener('click', function (event) {
        if (!_self.contains(event.target) && !_self.button.contains(event.target)) {
          _self.close();
        }
      });
    } else {
      this.addEventListener("focusout", function (event) {
        if ( this.contains(event.relatedTarget) || !document.hasFocus() ) {
          return;
        }
        this.close();  // or whatever logic you want to use to close
      });
    }

    this.initOptions();

    if (this.isAlternative) {
      document.addEventListener('click', (e) => {
        let isClickInside = this.contains(e.target);
        if (!isClickInside) {
          this.close();
        }
      });
    }

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close()
      }
    });
  }

  open() {
    this.button.setAttribute('aria-expanded', 'true');
    this.button.parentElement.classList.add('form-select--open');
    $(this.list).slideDown();
  }

  close() {
    this.button.setAttribute('aria-expanded', 'false');
    this.button.parentElement.classList.remove('form-select--open');
    $(this.list).slideUp();
  }

  initOptions() {
    this.optionsButton = this.querySelectorAll('.form-select__dropdown-button');
    this.options = this.querySelectorAll('.form-select__dropdown-option');

    this.optionsButton.forEach(option => {
      const callback = (e) => {
        const clickedOption = e.target.closest('.form-select__dropdown-option');
        this.close();
        if (clickedOption.getAttribute('aria-selected') === 'true') return;

        this.options.forEach(option => option.setAttribute('aria-selected', 'false'));
        clickedOption.setAttribute('aria-selected', 'true');
        this.buttonText.innerHTML = clickedOption.querySelector('.form-select__dropdown-button').innerHTML;
        if (clickedOption.getAttribute('data-option-value')) {
          this.inputHidden.value = clickedOption.getAttribute('data-option-value');
        } else {
          this.inputHidden.value = clickedOption.querySelector('[data-option-value]')?.getAttribute('data-option-value');
        }
        this.inputHidden.dispatchEvent(this.changeEvent);
        this.button.setAttribute('aria-selected', 'true');
      };

      option.addEventListener('click', callback);

      //fix for iOS
      if (this.dropdownLabel) this.dropdownLabel.addEventListener('click', ()=> this.close());
    })
  }
}

customElements.define('custom-select', customSelect);

//scroll to
if($('[data-anchor-link]').length > 0 ) {
  $('[data-anchor-link]').on('click', function (e) {
    e.preventDefault();

    const thisLink = $(this).attr('href');
    const thisLinkArr = thisLink.split('#');
    const thisLinkPageUrl = thisLinkArr[0];
    const pageUrl = window.location.origin + window.location.pathname;
    const header_offset = document.getElementById('site-header').offsetHeight + 20;
    if (thisLinkPageUrl === pageUrl) {
      const $elem = $(`[data-id="${thisLinkArr[1]}"]`);

      if ($elem) {
        $('html, body').animate({
          scrollTop: $elem.offset().top - header_offset
        }, 300, 'swing');

        window.history.replaceState(null,'', thisLink);
      }
    } else {
      window.location.href = thisLink;
    }
  });
}

